import { render, staticRenderFns } from "./task-link-select.vue?vue&type=template&id=6fcbb195&"
import script from "./task-link-select.vue?vue&type=script&lang=js&"
export * from "./task-link-select.vue?vue&type=script&lang=js&"
import style0 from "./task-link-select.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports